import { useEffect, useState } from 'react';

interface Props {
    className: string;
    url?: string;
    offset?: string | number;
    duration?: string | number;
}
const useVideo = ({ className, url, offset = '50%', duration = '100%' }: Props) => {
    const [src, setSrc] = useState('');
    useEffect(() => {
        if (typeof window !== 'undefined') {
            AniContainer.create({
                triggerElement: `.${className}`,
                triggerHook: 1,
                offset: '-400%',
                onEnter: () => {
                    setSrc(url ?? '');
                },
            });

            AniContainer.create({
                triggerElement: `.${className}`,
                triggerHook: 1,
                offset,
                duration,
                onEnter: () => {
                    const video: HTMLVideoElement | null = document.querySelector(`.${className} video`);
                    if (video) {
                        video.play();
                    }
                },
                onLeave: () => {
                    const video: HTMLVideoElement | null = document.querySelector(`.${className} video`);
                    if (video) {
                        video.pause();
                    }
                },
            });
        }
    }, []);

    return {
        src,
    };
};

export default useVideo;
